import React from 'react';
import { SuccessAutoDismissFlag } from '@atlassian/jira-flags';
import { useIntl } from '@atlassian/jira-intl';
import flagMessages from './messages';

type Props = {
	isConfigureBoardEnabled: boolean;
	id: string | number;
	numIssues: number;
	boardConfigUrl: string;
	onDismissed: undefined | ((arg1: string | number) => void);
};

export const CardCreateUnmappedFlag = ({
	onDismissed,
	id,
	numIssues,
	boardConfigUrl,
	isConfigureBoardEnabled,
}: Props) => {
	const { formatMessage } = useIntl();
	const getActions = isConfigureBoardEnabled
		? [
				{
					content: formatMessage(flagMessages.assignStatuses),
					href: boardConfigUrl,
				},
			]
		: [];

	const description =
		numIssues > 1
			? formatMessage(flagMessages.multipleIssuesHiddenDescription, { numIssues })
			: formatMessage(flagMessages.issueHiddenDescription);
	return (
		<SuccessAutoDismissFlag
			id={id}
			onDismissed={onDismissed}
			title={formatMessage(flagMessages.issueHiddenTitle, { numIssues })}
			description={description}
			actions={getActions}
		/>
	);
};
